import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { Feed, FeedRequestList } from '../../model/feed.model';
import { Occ } from '../../occ';
import { ConverterService } from '../../util';
import { FEED_NORMALIZER } from './converters';

@Injectable({
  providedIn: 'root',
})
export class FeedConnector {
  constructor(
    private httpClient: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converterService: ConverterService
  ) {}

  /*  Comment moved from old implementation of operations message - timestamp finally was not used
   *   TODO: ESVCX-1054 Why does not CORS work with timestamp?
   *  .get<Occ.OperationalMessage>(this.occEndpointsService.buildUrl('operationalMessage', {}, { timestamp }), {
   */
  getFeedData(userId: string, feedRequestList?: FeedRequestList): Observable<Feed> {
    return this.httpClient
      .post<Occ.Feed>(
        this.occEndpointsService.buildUrl('feed', {
          urlParams: {
            userId,
          },
        }),
        feedRequestList || {}
      )
      .pipe(this.converterService.pipeable(FEED_NORMALIZER));
  }
}
